<template>
  <div class="offline--icon u-box" v-if="isOffline">
    <span class="icon">
      <i class="fa fa-wrapper fa-huge fa-wifi"></i>
    </span>
  </div>
</template>
<style>
.offline--icon {
  position: fixed;
  right: 5%;
  top: 8.85rem;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0.5rem !important;
}
.offline--icon .icon {
  font-size: 2em;
  color: red;
  line-height: 100%;
}
@media only screen and (max-width: 1023px) {
  .offline--icon {
    right: 1rem;
  }
}
</style>
<script>
export default {
  name: "offline-icon"
};
</script>
